import React from 'react'

export const BannerBlog = ({ title, date, description}) => (
  <section id="banner" className="style2">
    <div className="inner">
      <header className="major">
        <h1>{title} - <span style={{fontWeight:200}}>{date}</span></h1>
      </header>
      <div className="content">
        <p>{description}</p>
      </div>
    </div>
  </section>
)

